import React from 'react';
import { useAdsBanner } from '../hooks/useAdsBanner';
import styles from '../styles/adsBanner.module.scss';

function AdsBanner() {
  const isTicketsPlayer = useAdsBanner();

  return !isTicketsPlayer ? (
    <div className={styles.banner}>
      <div className={styles.content}>320X50</div>
      <div className={styles.warning}>Tiсket players have no ADS 320X50</div>
    </div>
  ) : null;
}

export default AdsBanner;
